import { createTheme } from "@mui/material/styles";
import {
  generalBlack,
  generalDarkGrey,
  turismPrimary,
  turismSecondary,
} from "./colors";
import { ptBR } from "@mui/x-date-pickers/locales";

export const theme = createTheme(
  {
    palette: {
      primary: {
        main: turismPrimary,
      },
      secondary: {
        main: turismSecondary,
      },
      text: {
        primary: generalBlack,
        secondary: generalDarkGrey,
      },
    },

    typography: {
      fontFamily: `"Roboto", sans-serif`,
      fontSize: 15,
    },
  },
  ptBR
);
